module.exports = __webpack_public_path__ + "img/Icon_Unreported_Discipline.7421f742.svg";